<!--
 * @Description: 首页/用户信息
 * @Author: yingbin
 * @Date: 2019-08-27 17:29:49
 * @LastEditTime: 2019-09-09 18:19:54
 * @LastEditors: yingbin
 -->
<template>
  <div class="userInfo">
    <p>
      <span>用户名：</span>
      <span>{{userInfo.userName}}</span>
    </p>
    <p>
      <span>手机号：</span>
      <span>{{userInfo.mobile}}</span>
    </p>
    <p>
      <span>邮箱：</span>
      <span>{{userInfo.email}}</span>
    </p>
  </div>
</template>

<script>
import user from "../../apis/user_apis";
import { mapState } from "vuex";
export default {
  data() {
    return {
      userInfo:{}
    };
  },
  created() {
    this.name = this.$route.query.name;
    this.getUserInfo()
  },
  mounted() {
    
  },
  computed: {
    // ...mapState(["userInfo"])
  },
  methods: {
    getUserInfo(){
      user.getUserInfo(this).then(res => {
        this.userInfo = res.data
        this.$store.state.userInfo = res.data.userName;
      })
    }
  }
};
</script>

<style lang="less" scoped>
.userInfo {
  padding-left: 90px;
  padding-top: 10px;
  font-size: 16px;
  color: rgba(57, 55, 55, 1);

  span {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-right: 8px;
  }

  .title {
    display: flex;
    height: 80px;
    line-height: 80px;
    color: #393737;
    font-size: 18px;
    border-bottom: 2px solid rgba(229, 229, 232, 1);

    & p:nth-child(1) {
      width: 20%;

      & span:nth-child(1) {
        position: relative;
        top: 2px;
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-right: 14px;
        border-radius: 50%;
        border: 4px solid rgba(238, 152, 8, 1);
      }
    }
  }
}
</style>
